module.exports = __webpack_public_path__ + "img/doc_juan_2.85e18fc4.png";